var model = {
    'dodge': [
        { 'niceName': 'charger',       'id': '04', 'code': 'LDDM48A', 'llp': '2DG' },
        { 'niceName': 'challenger',    'id': '03', 'code': 'LADH22A', 'llp': '2DA' },
        { 'niceName': 'dart',          'id': '19', 'code': '', 'llp': '' },
        { 'niceName': 'viper',         'id': '07', 'code': 'ZDDH29A', 'llp': '2DH' },
        { 'niceName': 'journey',       'id': '09', 'code': 'JCDH49A', 'llp': '2DF' },
        { 'niceName': 'durango',       'id': '11', 'code': 'WDDL75A', 'llp': '2TA' },
        { 'niceName': 'grand-caravan', 'id': '05', 'code': 'RTKH53I', 'llp': '2DS' }
    ]
};

module.exports = {
    model: model
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-models2.js
// module id = 187
// module chunks = 0 1 23